import React, { PureComponent } from 'react';
import classNames from 'classnames';

class SelectDropdownField extends PureComponent {
  render() {
    const {
      helperText,
      className,
      errorMsg,
      labelText,
      labelClassName,
      selectClassName,
      helperTextClassName,
      htmlFor,
      listValues,
      defaultInitialValue,
      ...rest
    } = this.props;

    const wrapperClasses = classNames('select-dropdown-field ', className, {
      'select-dropdown-field--disabled': this.props.disabled
    });

    return <div className={wrapperClasses}>
      <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      <select id={htmlFor} {...rest} className={classNames(selectClassName, { [selectClassName + '--error']: errorMsg })} >
        <option value='' selected>{defaultInitialValue}</option>
        {
          listValues.map((val) => (
            <option
              key={val}
              value={val}
            >{val}</option>
          )
        )}
      </select>
      { helperText && <div className={classNames('txt-field-helper-msg', helperTextClassName)}>{helperText}</div> }
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

SelectDropdownField.defaultProps = {
  selectClassName: 'select-dropdown-field-input'
};

export default SelectDropdownField;

